import { isNumeric } from 'validator';

export function number({ min = null, max = null, required = true } = {}) {
  return fieldName => (value = '') => {
    if (!required && value === '') {
      return undefined;
    }
    if (!isNumeric(value || '')) {
      return `${fieldName} should be a number`;
    }

    if (min !== null && value < min) {
      return `Minimum value of ${min}`;
    }
    if (max !== null && value > max) {
      return `Maximum value of ${max}`;
    }

    return undefined;
  };
}
